import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useErrorContext } from './../../components/messages/ErrorBox';
import { usePageLoadingContext } from './../../components/messages/PageLoading';
import { useLocale } from './../../components/special/LanguageProvider';
import { apiGetCall, apiPostCall, isResultOk } from './../../components/special/apiCall';
import  EditForm  from 'components/form/EditForm';
import  EditFormFieldTable  from 'components/form/EditFormFieldTable';
import InputDropDownList from './../../components/input/InputDropDownList';
import TextDate from './../../components/text/TextDate';
import InputCheckBox from 'components/input/InputCheckBox';


const BASE_URL = process.env.REACT_APP_ILWEB_API_URL;

export const AgreementToContractEdit = ({history}) => {
  
  const params = new URLSearchParams(useLocation().search);  
  const setCheckErrorItems = useErrorContext();
  const setIsPageLoading = usePageLoadingContext();
  const { t } = useLocale();

   //Init blank formdata record.
   const [formData, setFormData] = useState({
    agrID : null,        
    isNew : null,
    cur : null,
    initDdId : null        
  });  

  //Init blank working data record
  const [workingData, setWorkingData] = useState({
      active : null,
      agreementID : null,
      collectionContractID : null,
      id : 0,
      registeredDate : new Date(),
      updatedDate : new Date()
  });

  const [lookupData, setLookupData] = useState({        
    connectionContractProspects : []
  });


  const goBack = () => {
    let agrID = params.get("agrID");
    history.push("/admin/agreements/edit?agrID=" + agrID);
  }

  const loadLookupData = async() =>{
    //Load all the data at the same time. 
    let newLookup = {...lookupData};
    let urlString = '';   
    let newStatus = params.get("new");
    //console.log("check befor lookup", formData)
    if(newStatus == 'true'){
      let tegund = params.get("teg");
      if (tegund == '1')
        urlString = '/admin/list/agreement/cancel/contracts/prospects';
      else
      urlString = '/admin/list/agreement/paymentallocation/contracts/prospects';
    } 
    else {
        urlString = '/admin/list/agreement/contracts/all';
    }
    let [connectionContractProspects] = await Promise.all([
      apiGetCall(BASE_URL + urlString ),
    ]);         
    newLookup.connectionContractProspects = connectionContractProspects;
    //console.log("newLookup", newLookup);
    //Translate the data into what we want to use.
    setLookupData( newLookup );
    lookupData.connectionContractProspects = connectionContractProspects;
    setLookupData( newLookup );
  }


  const loadFormData = async() => {
    setIsPageLoading(true);
    let newFormData = {...formData}; 


    //Lookup data.
    await loadLookupData();

    //Read the query parameters, if we don´t have any then go back to transaction keys.
    let newStatus = params.get("new");  
    newFormData.isNew = newStatus;
    let agreementID = params.get("agrID");  
    newFormData.agrID = agreementID; 
    let curID = params.get("cur");
    newFormData.cur = curID;
    let requestResult = null;
    if (newStatus == "false"){ 
        //console.log("ekki nytt");
      if (curID == null || curID <= 0){  
         // console.log("goback");    
        goBack();
      }    
      else{ 
        //  console.log("try to load for ", curID);    
        requestResult = await apiGetCall(BASE_URL + '/admin/agreement/connectedcontract/' + curID);   
       // console.log("lodaded data ", requestResult);    
        if (isResultOk(requestResult, setCheckErrorItems)){   
         //   console.log("setja workingdata");     
            setWorkingData(requestResult);  
          //  console.log("lllll", lookupData.connectionContractProspects.filter((it) => (it.data.collectionContractID == requestResult.collectionContractID))[0].itemID);
           newFormData.initDdId = (lookupData.connectionContractProspects.filter((it)=> (it.data.collectionContractID == requestResult.collectionContractID)))[0].itemID;                        
        }  
      }
    } else {
        let newData = {...workingData};
        newData.agreementID = agreementID;
        newData.updatedDate = null;
        setWorkingData({...newData, agreementID : agreementID});
    }
    
 //   console.log("lookupdata", lookupData);
 //   console.log("workingData", workingData);
    
   setFormData(newFormData);

   
  //  console.log("formdata", formData, newFormData);
    setIsPageLoading(false);
   
  }

  useEffect (() => {
    loadFormData(); 
  }, []);


  const onSaveClick = async() => {

    setIsPageLoading(true);
    let requestResult = null;
       if (formData.isNew == "false"){
            requestResult = await apiPostCall(BASE_URL + '/admin/agreement/connectedcontract/update', workingData);  
        } 
        else {
            requestResult = await apiPostCall(BASE_URL + '/admin/agreement/connectedcontract/create', {active: workingData.active, agreementID: workingData.agreementID, collectionContractID: workingData.collectionContractID, id: workingData.id, registeredDate: workingData.registeredDate } );
        }   
      //console.log("res", requestResult);
    // console.log("onsave", workingData);   
    if (isResultOk(requestResult, setCheckErrorItems)){          
      goBack();
    }
    setIsPageLoading(false);    
  }

  const onBackClick = () => {    
    goBack();
  }
  
  const validateInput = async () => {
    let messages = [];      

    
    return messages; 
  }

  const getInit = async(it) => {
      return 18;
  }

  const onSelectContract = async(value) => {
    let newData = {...workingData};
    let newForm = {...formData};
    setWorkingData({ ...newData, collectionContractID : lookupData.connectionContractProspects[value].data.collectionContractID});
    setFormData({...newForm, initDdId : value});
   // console.log("onselect", workingData, formData);
  }
 
  return (    
    <EditForm title={"Tengja samning við innheimtusamning"} onSubmitClick={onSaveClick} onBackClick={onBackClick} onValidate={validateInput}>
       <EditFormFieldTable fields={[
        {
            title: (1==1 ? "Test" : "Niðurfellingarsamningur"),
            edit : () => (<div>{workingData.agreementID}</div>)        
        }, 
        {
          title: "Innheimtusamningur",
          edit : () => <InputDropDownList
                        name="Innheimtusamningur"
                        disabled={false}
                        list={lookupData.connectionContractProspects}
                        keyField="itemID"
                        displayField = { (item) => { return item.name } }
                        defaultValue = { formData.initDdId}
                        onChange= {(value) => onSelectContract(value)}//setWorkingData({ ...workingData, collectionContractID : lookupData.connectionContractProspects[value].data.collectionContractID})} //{(value) => setWorkingData({ ...workingData, agreementTypeID : value})}
                        nullable={true}
                        nullableItem={{itemID: null, name: ""}}
                      />          
        },
        {
          title: "Virkur",
          edit : () => (<InputCheckBox name={"activeCB"} label={"Virkja / afvirkja"} value={workingData.active} onChange={ (value) => setWorkingData({ ...workingData, active : value}) }/>)      
        },  
        {
          title: "Skráð",
          edit : () => (<TextDate name="registerd" value={workingData.registeredDate}/>)       
        },
        {
            title: "Uppfært",
            edit : () => (<TextDate name="updated" value={workingData.updatedDate}/>)       
        },   
      ]}/>
       
       
       
    </EditForm>
  );
};